import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateProgram } from '../../../actions/Activites/Programmes';
import { baseUrl } from '../../../nametitle/dataUrl';

const ModalAddProgram = () => {
  const navigate = useNavigate("");

  const [title, settitle] = useState("")
  const [coverPicture, setcoverPicture] = useState("");
  const [description, setdescription] = useState("");

  const [Loading, setLoading] = useState();
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
      fileReader.onerror = (error) => { reject(error); };
    });
  }
  function uploadSingleImage(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChange = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleImage(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };


  return (
    <div className=" modal fade " id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content rounded-0">
          <div className="modal-header relative">
            <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>
              Ajouter un programme
            </h6>
            <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div className="modal-body container flex justify-center">
            <div className="flex justify-center row g-8">
              <div className="col-lg-9">
                <form onSubmit={(e) => {
                  e.preventDefault();
                  CreateProgram(title, coverPicture, description, navigate);
                }}>
                  <div className="row g-3">
                    <div className="col-12">
                      <input type="text" onChange={(e) => { settitle(e.target.value) }} value={title} required className="form-control bg-light border-0 px-4 py-1 translatable" placeholder="tittre ..." style={{ height: "40px" }} />
                    </div>
                    <div className="col-12 flex">
                      <input type="file" onChange={HandleFileInputChange} accept=".JPG,.JPEG,.PNG" required className="form-control bg-light border-0 px-4" placeholder="Votre email" style={{ height: "40px" }} />
                      {
                        coverPicture &&
                        (
                          <img src={`${coverPicture}`} className="h-[50px] h-[50px]" />
                        )
                      }
                    </div>
                    <div className="col-12">
                      <textarea onChange={(e) => { setdescription(e.target.value) }} value={description} required className="form-control bg-light border-0 px-4 translatable" placeholder="description ..." style={{ height: "155px" }} />
                    </div>
                    <div className="col-12">
                      <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Ajouter</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalAddProgram;
